import type { Component } from 'vue';
import iconifyIconOffline from './src/iconifyIconOffline';
import iconifyIconOnline from './src/iconifyIconOnline';
import fontIcon from './src/iconfont';

export const IconifyIconOffline: Component = iconifyIconOffline;
export const IconifyIconOnline: Component = iconifyIconOnline;
export const FontIcon: Component = fontIcon;
export { useRenderIcon } from './src/hooks';
